import { render, staticRenderFns } from "./PaymentsAndInvoicesSelector.vue?vue&type=template&id=701b810f&scoped=true&"
import script from "./PaymentsAndInvoicesSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndInvoicesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b810f",
  null
  
)

export default component.exports